import ManagerAreas from './ManagerAreas.container';

export default ManagerAreas;
